import { Auth } from "../../api/Channel/Auth";
import { ALLOW_ACCESS_DASHBOARD } from "auth/hooks/useLogin";
import CoreRadioChangeRole from "common/components/forms_context/CoreRadioChangeRole";
import { useOptions } from "common/hooks/useOptions";
import { LOCAL_STORAGE, getDataSession, setDataSession } from "helper/session";
import { ROLE, UAA_CHILDREN_PATH } from "modules/Channel/configs/constant";
import {
  getMenuItemsByRoles,
  menus,
} from "modules/Channel/configs/navigationConfig";
import {
  KEY_LIST_ROLE_BIZZ_UAA,
  KEY_ROLE_BIZZ_UAA,
  KEY_LIST_ACTIVE_ROLE
} from "modules/UAA/configs/constant";
import { useEffect, useState, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { Form, useNavigate } from "react-router-dom";
import { setCurrentMenuApp } from "redux/bizzAppReducer";
import { setCurrentPermission, setListMenu } from "../../redux/userReducer";
import { getApiByProduct } from "../../modules/UAA/service/permissionConfigService";
import { getUserSession } from "../../helper/user";
const ChangeRole = () => {
  const [isUpdateRole, setIsUpdateRole] = useState(false);
  const { mutateAsync: updateRole } = useMutation({
    mutationFn: Auth.updateRole,
    // onSuccess: ({ data }) => {
    //   const isSuccess = _.get(data, "message");
    //   if (isSuccess === "Success") {
    //     navigate("/");
    //   }
    // },
  });

  const { t } = useTranslation("uaa");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentRoleData = getDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA);
  const listRoleCurrent = getDataSession(LOCAL_STORAGE, KEY_LIST_ROLE_BIZZ_UAA);
  const listRoleActive = getDataSession(LOCAL_STORAGE, KEY_LIST_ACTIVE_ROLE);
  const form = useForm({ defaultValues: { role: currentRoleData?.code } });
  const { watch } = form;

  const roleOptions = useOptions(listRoleCurrent, "name", "code");
  const roleSelect = watch("role");
  useEffect(() => {

    const dataRole = { code: roleSelect };

    const chosenBizzAppMenu = getMenuItemsByRoles(
      { key: "", label: "" },
      menus,
      dataRole
    ).children;

    dispatch(setCurrentMenuApp(chosenBizzAppMenu || []));
    setDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA, dataRole);

    /**
     * When change role going to home page
     * After that call API update current selected role
     */
    (async () => {
      const _roleCurrent = listRoleCurrent?.find(
        (item) => item.code === roleSelect
      );
      const _roleActive = listRoleActive?.roles?.length <= 1 || !roleSelect ? listRoleActive?.roles[0] : listRoleActive?.roles?.filter(
        (item) => item.alias.toUpperCase() === roleSelect.replace(/_/g, "").toUpperCase()
      )?.[0];
      const listApi = await getApiByProduct({ page: 0, size: 2000, roleId: _roleActive.id });

      dispatch(setListMenu(listApi.data?.data?.content.filter(ele => ele.viewType === 'MENU') ?? null));
      setIsUpdateRole(true);

      const isRedirectDashboard = ALLOW_ACCESS_DASHBOARD.includes(roleSelect);

      setDataSession(LOCAL_STORAGE, "isLogin", true);

      if (isUpdateRole) {
        isRedirectDashboard && roleSelect !== ROLE.ADMIN
          ? navigate(UAA_CHILDREN_PATH.ULTILITIES_DASHBOARD)
          : navigate("/");
        await updateRole(_roleCurrent.coreRoleId);
      }
    })();
  }, [roleSelect]);

  return (
    <>
      <FormProvider {...form}>
        <Form>
          <CoreRadioChangeRole
            name="role"
            legendLabel={t(`label.role`)}
            classNameRadioGroup="flex flex-row"
            options={roleOptions}
            required
            gridItem={false}
            classNameLabel="px-6"
          />
          {/* <div className="flex items-center">
            Select role:
            <CoreAutocomplete
              name="role"
              className="min-w-[240px]"
              options={roleOptions}
              // loading={isLoading}
              disableClearable
              // disabled={isLoading}
            />
          </div> */}
          <hr className="my-5" />
        </Form>
      </FormProvider>
    </>
  );
};

export default ChangeRole;
